export class AbortedByUserError extends Error {
  constructor(public readonly reason: unknown) {
    super();
  }
}
